module.exports = __webpack_public_path__ + "static/media/custom_solutions.a90201f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/custom_solutions.svg
// module id = 162
// module chunks = 0